import Vue from 'vue'
import Router from 'vue-router'

// 新闻
import NewsIndex from '../components/news/Index'
import NewsDetail from '../components/news/Detail'
import NewsCateIndex from '../components/news/CateIndex'
//商城
import ShopIndex from '../components/shop/Index'
import Cate from '../components/shop/Cate'
import Address from '../components/address/Address'
import Integral from '../components/uc/Integral'
//购物车
import Cart from '../components/cart/Index'
import Tihuo from "../components/uc/Tihuo";

/*个人中心*/
import UcIndex from '../components/uc/Index'
import UcBalance from '../components/uc/Balance'
import UcOrder from '../components/uc/OrderLists'
import UcOrderDetail from '../components/uc/OrderDetail'
import UcMemberInfo from '../components/uc/MemberInfo'
import UcReferInfo from '../components/uc/ReferInfo'
import UcMemberOrder from '../components/uc/MemberOrder'
import UcChildList from '../components/uc/ChildList'
import UcSetting from '../components/uc/Setting'
import UcSetMobile from '../components/uc/SetMobile'
import UcAddress from '../components/uc/Address'
import UcBankCard from '../components/uc/BankCard'
import UcWithDraw from '../components/uc/WithDraw'
import UcPromiseBalance from '../components/uc/PromiseBalance'
import UcPromiseBalanceList from '../components/uc/PromiseBalanceList'
import UcJoin from '../components/uc/Join'
import UcJoinDetail from '../components/uc/JoinDetail'
import RefIndex from '../components/uc/ReferImgIndex'
import UserCard from '../components/uc/UserCard'
import AgentOrderList from '../components/uc/AgentOrderList'
import AdminStatic from '../components/uc/AdminStatic'
import AdminMemberInfo from '../components/uc/AdminMemberInfo'
import AdminOrderList from '../components/uc/AdminOrderList'
import TransferStock from "../components/uc/TransferStock";
import StockLog from "../components/uc/StockLog";
import stockDetail from "../components/uc/stockDetail";
import sellerRequest from '../components/sellerRequest/SellerRequest';

import Test2 from '../components/Test2'
import Error from '../components/Error'

import SellerRecharge from '../components/uc/SellerRecharge'
import SellerRechargeList from '../components/uc/SellerRechargeList'
/*春节活动*/
import NewYearActivity from '../components/newYearActivity/Index'
import NewYearActivityRule from '../components/newYearActivity/rule'
import NewYearActivityMyPackage from '../components/newYearActivity/mypackage'
import NewYearActivityForm from '../components/newYearActivity/from'

Vue.use(Router);

const EmptyBox = {
  template: `
  <router-view></router-view>
  `
};

export default new Router({
  mode: 'history',
  base: 'html',
  routes: [
    {path: '/test', component: Test2},
    {name: 'error', path: '/error/:desc', component: Error, props: true},

    //2018春节活动
    {path: '/newyearactivity', name: 'newyearactivity', component: NewYearActivity},
    {path: '/newyearactivityrule', name: 'newyearactivityrule', component: NewYearActivityRule},
    {path: '/newyearactivityform', name: 'newyearactivityform', component: NewYearActivityForm},
    {path: '/newyearactivitymypackage', name: 'newyearactivitymypackage', component: NewYearActivityMyPackage},

    /* 首页 */
    {path: '/', name: 'shop', component: ShopIndex},
    /* 新闻 */
    {
      path: '/news',
      component: EmptyBox,
      children: [
        {path: '', component: NewsIndex},
        {path: 'index', component: NewsIndex},
        {path: ':id', component: NewsDetail, props: true},
        {path: 'cate/:cateId', component: NewsCateIndex, props: true},
      ]
    },

    /* 商城 */
    {
      path: '/shop',
      component: EmptyBox,
      children: [
        {path: '', component: ShopIndex},
        {path: 'index', component: ShopIndex},
        {path: 'Cate/:cateId', component: Cate},
      ]
    },

    /*购物车*/
    {path: '/cart', component: Cart, name: 'cart'},
    {path: '/cart/:oldOrderId', component: Cart, name: 'cartOld', props: true},
    /*地址*/
    {path: '/address', component: Address},

    /*个人中心*/
    {path: '/uc/index', component: UcIndex},
    {path: '/uc/balance', component: UcBalance},
    {path: '/uc/order/:orderType', component: UcOrder, props: true},
    {path: '/uc/orderDetail/:orderId', component: UcOrderDetail, name: 'orderDetail', props: true},
    {path: '/uc/stockDetail/:id', component:stockDetail, name: 'stockDetail', props: true},
    {path: '/uc/member/:memberId', component: UcMemberInfo, props: true},
    {path: '/uc/refer/:memberId', component:UcReferInfo, props: true},
    {path: '/uc/member/order/:uid', component: UcMemberOrder, props: true},
    {path: '/uc/child/:memberId', component: UcChildList, props: true},
    {path: '/uc/setting/', component: UcSetting},
    {path: '/uc/mobile/', component: UcSetMobile},
    {path: '/uc/address/', component: UcAddress},
    {path: '/uc/bankcard/', component: UcBankCard},
    {path: '/uc/withdraw/', component: UcWithDraw},
    {path: '/uc/promisebalance/:cate', component: UcPromiseBalance, props: true},
    {path: '/uc/joinus/', component: UcJoin},
    {path: '/uc/joinusdetail/:id/:name', component: UcJoinDetail, props: true},
    {path: '/uc/promisebalancelist/:cateId', component: UcPromiseBalanceList,props: true},
    {path: '/uc/integral/', component: Integral},
    {path: '/uc/usercard/', component: UserCard},
    {path: '/uc/referindex/', component: RefIndex},
    {path: '/uc/agentorder/:orderType', component: AgentOrderList, props: true},
    {path: '/uc/adminstatic', component: AdminStatic},
    {path: '/uc/adminorderlist', component: AdminOrderList},
    {path: '/uc/adminmemberinfo', component: AdminMemberInfo},
    {path: '/uc/transfer-stock/:memberId', component: TransferStock,props: true},
    {path: '/uc/stock-log/:memberId', component: StockLog,props: true},
    {path: '/uc/seller_recharge/', component: SellerRecharge},
    {path: '/uc/seller_recharge_list/', component: SellerRechargeList},
    {path: '/uc/tihuo/', component:Tihuo},
    {path: '/uc/seller-request/', component:sellerRequest},
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js